<app-nav></app-nav>

<section class="add-policy">
  <div id="snackbar"></div>
  <div class="container">

    <h4 class="form-title">Add Policy Details</h4>

    <form #f="ngForm">

      <!-- HOLDER NAME -->
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="form-group">
            <label class="title mendatory">Policy Holder Name</label>

            <input class="form-control" type="text" name="holderName" placeholder="Enter Policy Holder Name"
              [(ngModel)]="data.holderName" #holderName="ngModel" pattern="[a-zA-Z\s]+" required>

            <div *ngIf="holderName.invalid && holderName.touched" class="error-message">
              <div *ngIf="holderName.errors?.required">Policy Holder Name is required</div>
              <div *ngIf="holderName.errors?.pattern">Only alphabets allowed</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-group">
            <label class="title mendatory">Policy Number</label>

            <input class="form-control" type="text" name="policyNumber" placeholder="Enter Policy Number"
              [(ngModel)]="data.policyNumber" #policyNumber="ngModel" pattern="[a-zA-Z0-9\s]+" required>

            <div *ngIf="policyNumber.invalid && policyNumber.touched" class="error-message">
              Invalid Policy Number
            </div>
          </div>
        </div>
      </div>

      <!-- INSURER + PRODUCT -->
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="form-group">
            <label class="title mendatory">Insurer</label>

            <select class="form-control" [(ngModel)]="data.insurer" name="insurer" #insurer="ngModel" required>

              <!-- Placeholder -->
              <option [ngValue]="null" disabled hidden>
                Select Insurer
              </option>

              <!-- Options -->
              <option *ngFor="let i of insurerList" [ngValue]="i">
                {{ i.name }}
              </option>

            </select>

            <div *ngIf="insurer.invalid && insurer.touched" class="error-message">
              Insurer is required
            </div>
          </div>
        </div>

        <div class="col-md-6 col-12">
          <div class="form-group">
            <label class="title mendatory">Product Name</label>

            <select class="form-control" [(ngModel)]="data.productName" name="productName" #productName="ngModel"
              required>
              <option [ngValue]="null" disabled hidden>
                Select Product
              </option>
              <option *ngFor="let p of productList" [ngValue]="p">
                {{ p.name }}
              </option>
            </select>

            <div *ngIf="productName.invalid && productName.touched" class="error-message">
              Product Name is required
            </div>
          </div>
        </div>
      </div>

      <!-- DATES -->
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="form-group">
            <label class="title">Policy Start Date</label>

            <input type="date" class="form-control" [(ngModel)]="data.policyStartDate" name="policyStartDate"
              #policyStartDate="ngModel" [max]="currentDate | date:'yyyy-MM-dd'" required>

              <div *ngIf="policyStartDate.invalid && policyStartDate.touched" class="error-message">
                <div *ngIf="policyStartDate.errors?.required">Policy Start Date is required</div>
                <div *ngIf="policyStartDate.errors?.max">Start Date cannot be in the future</div>
              </div>  
          </div>
        </div>

        <div class="col-md-6 col-12">
          <div class="form-group">
            <label class="title mendatory">Policy End Date</label>

            <input type="date" class="form-control" [(ngModel)]="data.renewalDate" name="renewalDate"
              #renewalDate="ngModel" [min]="data.policyStartDate | date:'yyyy-MM-dd'" required>

            <div *ngIf="renewalDate.invalid && renewalDate.touched || renewalDateRequired" class="error-message">
              Policy End Date is required
            </div>
          </div>
        </div>
      </div>

      <!-- SUM + PREMIUM -->
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="form-group">
            <label class="title mendatory">Sum Insured</label>

            <input class="form-control" type="text" name="sumInsured" placeholder="Enter Sum Insured"
              [(ngModel)]="data.sumInsured" #sumInsured="ngModel" pattern="^\d{0,10}(\.\d{1,2})?$" required>

            <div *ngIf="sumInsured.invalid && sumInsured.touched" class="error-message">
              <div *ngIf="sumInsured.errors?.required">Sum Insured is required</div>
              <div *ngIf="sumInsured.errors?.pattern">Invalid Sum Insured</div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-12">
          <div class="form-group">
            <label class="title mendatory">Premium Paid</label>

            <input class="form-control" type="text" name="premium" placeholder="Enter Premium Amount"
              [(ngModel)]="data.premium" #premium="ngModel" pattern="^\d{0,10}(\.\d{1,2})?$" required>

            <div *ngIf="premium.invalid && premium.touched" class="error-message">
              <div *ngIf="premium.errors?.required">Premium Paid is required</div>
              <div *ngIf="premium.errors?.pattern">Invalid Premium Amount</div>
            </div>
          </div>
        </div>
      </div>

      <!-- FILE -->
      <div class="row">
        <div class="col-md-12 col-12">
          <div class="form-group">
            <label class="title">Upload Document</label>

            <div class="upload-box">
              <input type="file" (change)="onFileChanged($event)" />
              <small>Supported: PDF, JPG, PNG (10KB - 15MB)</small>
            </div>
          </div>
        </div>
      </div>

      <!-- SUBMIT -->
      <div class="text-center mt-3">
        <button class="btn btn-bordered-blue" type="button" [disabled]="f.invalid || uploading"
          (click)="addPolicyDetails()">
          Save Policy
        </button>
      </div>

    </form>
  </div>
</section>